<script context="module">
    import {writable} from 'svelte/store'
    import {determineHost} from "../config";
    export const info = writable({isLoggedIn:false, loading:true})
    export const host = determineHost();
    export function refresh() {
      return fetch(`${host}/hh`, {credentials:"include"})
        .then(() => fetch(`${host}/login/info`, {credentials:"include"})
          .then(response => response.json())
          .then(i => info.update(() => i))
        )
    }
</script>

<script>
      function logOut() {
        fetch(`${host}/logout`, {credentials:"include", method: "post"})
          .then(() => refresh())
      }

    refresh()

    setInterval(refresh, 15*60*1000)
</script>

<svelte:options accessors/>
<div>
    {#if $info.isLoggedIn}
        {#if $info.info.picture}
            <img src={$info.info.picture}>
        {/if}
        <span>{$info.info.name || $info.info.email}</span>
        <a href="#" on:click|preventDefault={logOut}>Logout</a>
    {:else}
        <a href="{host}">Login</a>
    {/if}
</div>


<style>
    img {
        max-width: 30px;
    }
    div {
        display: flex;
        align-items: center;
    }
    div>* {
        margin-right: 10px;
    }
</style>
